// extracted by mini-css-extract-plugin
module.exports = {"donate":"donate-EqQnpBmZ"};